import request from '../request.js'

export const classifys = data=>{
	return request({
		url:`classifys?pageNo=${data.pageNo}&pageSize=${data.pageSize}`,
		method:"get"
	})
}

export const updateClassify = data=>{
	return request({
		url:"updateClassify",
		method:"post",
		data
	})
}

export const addClassify = data=>{
	return request({
		url:"addClassify",
		method:"post",
		data
	})
}

export const delClassify = id=>{
	return request({
		url:"deleteClassify?id=" + id,
		method:"get"
	})
}